import React, { useRef } from "react";
import ModalContentBaseXl from "../../components/modal/modal_content_base_xl";

const RecommendTab = ({ data }) => {
  const { circleId, blogs, events, userSignedIn, isCircleMember, myFollowingFutureEventIds, albums, circleName, companyId, hashedCompanyId, isOshikatsu } = data;
  const modalRef = useRef(null);
  const limitedEvents = events ? events.slice(0, 6) : [];
  const limitedBlogs = blogs ? blogs.slice(0, 6) : [];
  const baseCircleUrl = companyId ? `/community/${hashedCompanyId}/circle/${circleId}` : `/circle/${circleId}`;
  const eventsMoreLink = `/circle/${circleId}/events`;
  const blogsMoreLink = companyId ? `${baseCircleUrl}/more_blogs` : `/circle/${circleId}/more_blogs`;
  const createEventLinkForHobby = companyId ? `/events/new/${circleId}?company_id=${companyId}`: `/events/new/${circleId}`;
  const createEventLinkForOshikatsu = `/events/new?parent_circle_id=${circleId}`;
  const createEventLink = isOshikatsu ? createEventLinkForOshikatsu : createEventLinkForHobby;

  const handleEventCreate = (e) => {
    e.preventDefault();
    if (modalRef.current) {
      modalRef.current.openModal();
    } else {
      window.location.href = createEventLink;
    }
  };

  const handleProceed = () => {
    if (modalRef.current) {
      modalRef.current.closeModal();
    }
    window.location.href = createEventLink;
  };

  return (
    <div className={"container-fluid px-0 mx-0"}>
      {/* イベント一覧 */}
      {limitedEvents && limitedEvents.length > 0 && (
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-fw-bold h2 h2--extend -member2 mt-4">イベント</h2>
            <a href={eventsMoreLink}  style={{ fontSize:'14px' }}>すべて見る</a>
          </div>
          <div className="row no-gutters">
            {limitedEvents.map((event, index) => {
              const eventDetailLink = companyId 
              ? `${baseCircleUrl}/events/${event.id}`
              : `/circle/${circleId}/events/${event.id}`;
              return (
                <div 
                  key={event.id}
                  className={`col-12 col-md-6 p-2 px-0 mx-0 ${index >=4 ? 'd-none d-md-block':''}`}
                >
                  <div className="bg-white search-shadow rounded h-100">
                    <a href={eventDetailLink} className="hov--default" style={{ display: 'flex', height: '100%' }}>
                      <div style={{
                        flex: '2 0 60%',
                        padding: '10px',
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', }}>
                        <div className="flex-grow-1" 
                          style={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '4px', }}>
                          {/* 日付 */}
                          <div 
                            className="d-inline-block px-2 py-1 border bg-light"
                            style={{
                              fontSize: '12px',
                              fontWeight: 'bold',
                              borderRadius: '10px',
                              color: '#333',
                              width: 'fit-content',
                            }}
                          >
                            {event.event_date_formatted}
                          </div>
                          {/* 開催地 */}
                          {!event.is_online ? (
                            <p className="mt-0 mb-0 line-1 icon icon-area text-fz-small text-fw-bold" style={{ margin: 0 }}>
                              {event.countries_pref
                                ? event.countries_pref.name
                                : (event.circle?.countries_pref?.name || '')}
                            </p>
                          ) : (
                            <p className="mt-0 mb-0 line-1 icon icon-online text-fz-small text-fw-bold" style={{ margin: 0 }}>
                              オンライン
                            </p>
                          )}
                        </div>
                          {/* タイトル */}
                          <p className="mb-0" style={{fontSize:'13px', fontWeight:'bold', lineHeight:'1.2'}}>
                            {event.title}
                          </p>
                          {/* 参加者アイコン */}
                          {(event.valid_events_plans_users?.length > 0 || event.valid_events_follows?.length > 0) && (
                            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                              {event.valid_events_plans_users?.slice(0, 7).map((planUser, i) => {
                                const src = planUser.company_id
                                  ? planUser.companies_user?.avatar_tiny
                                  : planUser.user?.avatar_tiny;
                                return (
                                  <img
                                    key={`planUser-${i}`}
                                    src={src}
                                    alt="participant"
                                    className="rounded-circle"
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      objectFit: 'cover',
                                      marginRight: '-8px',
                                      border: '2px solid #fff',
                                    }}
                                    onError={e => (e.currentTarget.src = '/images/ja2/img_noimage.gif')}
                                  />
                                );
                              })}
                              {event.valid_events_follows?.slice(0, 10).map((follow, i) => {
                                const src = follow.company_id
                                  ? follow.companies_user?.avatar_tiny
                                  : follow.user?.avatar_tiny;
                                return (
                                  <img
                                    key={`follow-${i}`}
                                    src={src}
                                    alt="participant"
                                    className="rounded-circle"
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      objectFit: 'cover',
                                      marginRight: '-8px',
                                      border: '2px solid #fff',
                                    }}
                                    onError={e => (e.currentTarget.src = '/images/ja2/img_noimage.gif')}
                                  />
                                );
                              })}
                            </div>
                          )}
                          <p className="mb-0 line-1 text-fz-xs text-gray d-flex align-items-center">
                            {!companyId && (
                              <span>{event.circle.name}</span>
                            )}
                          </p>
                      </div>
                      <div style={{ 
                        flex: '1 0 40%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent:'center', }}>
                        <div className="adjust-box adjust-box-16x9"
                          style={{
                            width: '100%',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                          }}
                        >
                          <img
                            src={event.main_image_url_thumb || "/images/ja2/img_noimage.gif"}
                            alt={event.title}
                            className="object-fit-contain adjust-box-inner bg-graydark3"
                            onError={(e) => {
                              e.target.src = "/images/ja2/img_noimage.gif";
                            }}
                            style={{
                              borderRadius: '4px',
                            }}
                          />
                          {event.is_full && (
                            <img
                              src="/assets2019/img/event/img-event_sold_out.svg"
                              className="event-bosyu position-absolute rounded"
                              style={{ height: "60%", top:'0', left:'0' }}
                              alt="満員"
                            />
                          )}

                          {userSignedIn && (
                            <button
                              className="btn-follow event-list-follow"
                              style={{
                                position: 'absolute',
                                height: '36px', 
                                width: '36px', 
                                padding: '0', 
                                background: 'transparent', 
                                border: 'none',
                                bottom: '5px',
                                right: '5px',
                              }}
                              data-event_id={event.id}
                              data-circle_id={event.circle_id}
                              data-followed={myFollowingFutureEventIds && myFollowingFutureEventIds.includes(event.id) ? 'true' : 'false'}
                            >
                              <img
                                src={
                                  (myFollowingFutureEventIds && myFollowingFutureEventIds.includes(event.id)) ?
                                  '/assets2019/img/favorite_black_24dp.svg' :
                                  '/assets2019/img/favorite_border_black_24dp.svg'
                                }
                                alt="お気に入り"
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {/* 予定されているイベントが無いとき。この欄は「開催日が今日以降」だけを出すので、
          過去にたくさん開いていても0件になり得る。「最初の」とは書かない */}
      {(!limitedEvents || limitedEvents.length === 0) && (
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-fw-bold h2 h2--extend -member2 mt-4">イベント</h2>
            <a href={eventsMoreLink} style={{ fontSize: '14px' }}>すべて見る</a>
          </div>
          <div className="cp-evempty">
            <p className="cp-evempty__title">予定されているイベントはありません</p>
            <p className="cp-evempty__text">
              {isCircleMember
                ? 'イベントを企画して、メンバーに知らせてみましょう。'
                : '新しいイベントが公開されると、ここに表示されます。'}
            </p>
          </div>
        </div>
      )}
        {isCircleMember && (
          <div style={{ paddingTop: '10px', paddingBottom: '16px' }}>
            <div className="container mt-3 d-flex justify-content-center">
              {isOshikatsu ? (
                <ModalContentBaseXl
                  ref={modalRef}
                  previewContent={
                    <button
                      className="a-button a-button__top a-button--orange text-white mb-2"
                      style={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}
                      onClick={handleEventCreate}
                    >
                      イベントを企画する
                    </button>
                  }
                  modalContent={
                    <div className="modal-content p-4">
                      <div className="container" style={{ maxWidth: '650px' }}>
                        <div className="row justify-content-center">
                          <div className="col-12">
                            <div className="process-flow mb-4">
                              <p className="mb-2 mt-3">
                                <i className="fas fa-check-circle text-success mr-2"></i>
                                <strong>イベント作成の流れ</strong>
                              </p>
                              <p className="mb-1 pl-4">
                                1. あなたの主催しているサークルでイベントを作成
                              </p>
                              {/* <p className="mb-0 pl-4">
                                2. 自動で{circleName}サークルと連携し、この公式サークルページで参加者の募集開始！
                              </p> */}
                              <p className="mb-0 pl-4">
                                2. この{circleName}サークルページでも参加者の募集開始！
                              </p>
                            </div>
                            <div className="text-center">
                              <button 
                                className="a-button a-button__top a-button--orange text-white mb-2"
                                style={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}
                                onClick={handleProceed}
                              >
                                イベントを作成する
                              </button>
                              <p className="text-fz-12px text-muted mt-3 mb-0">
                                ※イベント作成ページに飛びます。
                              </p>
                              <p className="text-fz-12px text-muted">
                                ※イベント作成後、自動的に{circleName}サークルページにイベントが公開されます。
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                />
              ) : (
                <a
                className="a-button a-button__top a-button--orange text-white mb-2"
                href={createEventLink}
                style={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}
                >
                  イベントを企画する
                </a>
              )}
            </div>
          </div>
        )}
      {/* ブログ一覧 */}
      {limitedBlogs && limitedBlogs.length > 0 && (
      <div>
        <div className="d-flex justify-content-between mt-4 align-items-center">
          <h2 className="text-fw-bold h2 h2--extend -member2 mt-4">ブログ</h2>
          <a href={blogsMoreLink} style={{ fontSize:'14px' }}>すべて見る</a>
        </div>
        <div className="row">
          {limitedBlogs.map((blog) => {
            let blogLabel = '';
            if (blog.is_draft) {
              blogLabel = '下書き';
            } else if (blog.public_type === 1) {
              blogLabel = (new Date(blog.publish_datetime) < new Date()) ? '' : '未公開';
            } else {
              // 正式メンバーだけに見える記事。フォロワーや非メンバーには一覧にも出ない
              blogLabel = 'メンバー限定';
            }
            let blogImageUrl = blog.image_url_medium || blog.pdf_thumb_url || 'https://tunagate.com/images/ja2/img_noimage.gif';
            const isPublishable = (!blog.is_draft && blog.publish_datetime && new Date (blog.publish_datetime) < new Date());
            let blogLink = null;
            if (isPublishable) {
              if (blog.public_type === 1) {
                blogLink = companyId
                  ? `${baseCircleUrl}/blogs/${blog.id_to_param}`
                  : `/blogs/${blog.id_to_param}`;
              } else {
                blogLink = companyId
                  ? `${baseCircleUrl}/notes/${blog.id_to_param}`
                  : `/my_circle/${circleId}/notes/${blog.id_to_param}`;
              }
            }

            const avatarUrl = blog.user && blog.user.avatar_medium ? blog.user.avatar_medium : '/images/ja2/img_noimage.gif';

            return (
              <div
                key={blog.id}
                className="mr-0 ml-0 px-0 pb-4 row justify-content-center col-6 col-md-4"
              >
                {/* 画像と文字を1枚の白いカードにまとめる器 */}
                <div className="cp-blogcard col-12 px-0">
                <div className="rounded col-12 px-2 position-relative">
                  <span
                    className={`${blog.is_draft ? 'bg-black-50 text-white' : 'badge-danger'} badge text-fw-bold px-2 py-1`}
                    style={{ top: '6%', left: '6%', position: 'absolute' }}
                  >
                    {blogLabel}
                  </span>
                  <img
                    className="card-img-top card-img-top--list_report_small rounded"
                    src={blogImageUrl}
                    alt={blog.title || 'No Title'}
                    style={{ objectFit: 'cover', maxHeight: '170px' }}
                    onError={(e) => {
                      e.target.src = 'https://tunagate.com/images/ja2/img_noimage.gif';
                    }}
                  />
                </div>
                <div className="col-12 px-3 pt-1 pb-2">
                  <h3
                    className="text-fw-bold mb-2 text-fz-13px line-2 text-black-444"
                    style={{ height: '40px', lineHeight: '1.2' }}
                  >
                    {blogLink ? (
                      <a href={blogLink}>{blog.title}</a>
                    ) : (
                      blog.title
                    )}
                  </h3>
                  <div className="cp-blogmeta mb-2 d-flex justify-content-between align-items-center">
                    <span className="cp-blogmeta__author">
                      <img
                        src={avatarUrl}
                        className="rounded-circle"
                        alt="avatar"
                        style={{ height: '24px', width: '24px', objectFit: 'cover' }}
                        onError={(e) => { e.target.src='/images/ja2/img_noimage.gif' }}
                      />
                    </span>
                    <span className="cp-blogmeta__date">
                      {/* 日付は 2025/04/23 の形にする（ハイフンは使わない） */}
                      {(blog.publish_datetime && blog.publish_datetime.substring(0, 10).replace(/-/g, '/')) || 'No Date'}
                    </span>
                  </div>
                </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      )}
      {albums && albums.length > 0 && (
        <section className="mb-4">
          <div className="d-flex justify-content-between mt-2 align-items-center">
            <h2 className="h2 h2--extend mb-3_5 mt-4">アルバム</h2>
            <a href={companyId ? `${baseCircleUrl}/album/list` : `/circle/${circleId}/album/list`} style={{ fontSize:'14px' }}>アルバムを見る</a>
          </div>
          <div className="container">
            <div className="row flex-nowrap overflow-auto px-2 pb-3">
              {albums.map((album) => {
                const photoUrl = album.first_picture || '/images/ja2/img_noimage.gif';
                const albumLink = companyId
                  ? `${baseCircleUrl}/album/${album.id}` : `/circle/${circleId}/album/${album.id}`;
                return (
                  <div key={album.id} className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 px-0 mr-2">
                    <div className="bg-white search-shadow rounded h-100">
                      <a href={albumLink} className="hov--default">
                        <div className="adjust-box adjust-box-3x2">
                          <img
                            src={photoUrl}
                            alt={album.title}
                            className="rounded-top w-100 object-fit-cover adjust-box-inner"
                            style={{ objectFit: 'cover' }}
                            onError={(e) => { e.target.src='/images/ja2/img_noimage.gif'; }}
                          />
                        </div>
                        <div className="p-2">
                          <p className="text-fz-small text-fw-bold line-1 mb-0">
                            {album.title}
                          </p>
                          <p className="text-fz-small text-fw-bold text-right mb-1">
                            {(album.albums_photos && album.albums_photos.length) || 0} 枚
                          </p>
                          <p className="text-fz-xs text-gray line-1 mb-0">サークル：{circleName}</p>
                        </div>
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default RecommendTab;
